export interface ICreateUser {
  full_name: string;
  email: string;
  password: string;
  role: number;
}

export interface IUpdateUser {
  full_name?: string;
  email?: string;
  role?: number;
  password?: string;
  deleted_at?: Date | null;
}

export const ROLES = {
  ADMIN: 1,
  VIEW_ONLY: 2,
};
